import { Box, Button, Skeleton } from "@mui/material";
import { API_URL, BootstrapTooltip } from "../../utilities";
import PageTitle from "../../components/PageTitle";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  GridActionsCellItem,
  GridColDef,
  GridRenderCellParams,
  GridRowId,
  GridRowModel,
  GridRowModes,
  GridRowModesModel,
  GridToolbarContainer,
} from "@mui/x-data-grid";
import moment from "jalali-moment";
import GridViewMUIX from "../../components/GridViewMUIX";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useAuth } from "../../context/auth";
import { MouseEvent, useEffect, useState } from "react";
import { useNotifications } from "@toolpad/core/useNotifications";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import PopoverComponent from "../../components/PopoverComponent";
import NewSaleFunnel from "./new-sale-funnel";
import SkeltonProgress from "../../components/SkeltonProgress";
import ChecklistRtlIcon from "@mui/icons-material/ChecklistRtl";
import { ISaleFunnelItem } from "src/interface/ISaleFunnelItem";
import { ISaleFunnel } from "src/interface/ISaleFunnel";
import ShowSalesFunnelInfo from "./show-sale-funnel-info";
import {
  PermissionGuard,
  ActionPermissionGuard,
  usePermissions,
} from "../../utilities/permissions";

const SalesFunnelList = () => {
  const notifications = useNotifications();
  const { user } = useAuth();
  const { canEdit, canDelete } = usePermissions();
  const { isLoading, error, data, refetch } = useQuery({
    queryKey: ["SalesFunnelData"],
    queryFn: () =>
      fetch(API_URL + "sale-funnel", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${user?.token}`,
          Aceept: "application/json",
        },
      }).then((res) => res.json()),
  });
  const [rows, setRows] = useState<any>();
  const [openTask, setOpenTask] = useState<boolean>(false);

  useEffect(() => {
    if (error) {
      notifications.show("خطا در دریافت اطلاعات" + error.toString(), {
        severity: "error",
        autoHideDuration: 3000,
      });
      console.log(error);
    }
  }, [error]);

  useEffect(() => {
    data && setRows(data);
  }, [data, user?.token]);
  const [rowModesModel, setRowModesModel] = useState<GridRowModesModel>({});

  const columns: GridColDef[] = [
    {
      field: "title",
      headerName: "عنوان",
      align: "left",
      headerAlign: "left",
      editable: true,
      sortable: true,
      flex: 1,
    },
    {
      field: "isActive",
      headerName: "فعال",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: true,
      minWidth: 80,
      type: "boolean",
    },

    {
      field: "createdOn",
      headerName: "تاریخ ثبت",
      sortable: true,
      headerAlign: "center",
      align: "center",
      minWidth: 120,
      renderCell: (params: GridRenderCellParams<any, string>) =>
        `${
          params.value &&
          moment.from(params.value, "en", "YYYY-MM-DD").format("jYYYY/jMM/jDD")
        }`,
    },
    {
      field: "modifiedOn",
      headerName: "آخرین تغییرات",
      headerAlign: "center",
      align: "center",
      sortable: true,
      minWidth: 120,
      renderCell: (params: GridRenderCellParams<any, string>) =>
        `${
          params.value &&
          moment.from(params.value, "en", "YYYY-MM-DD").format("jYYYY/jMM/jDD")
        }`,
    },
    {
      field: "actions",
      type: "actions",
      headerAlign: "center",
      headerName: "عملیات",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
      cellClassName: "actions",
      minWidth: 150,
      getActions: (params) => {
        const isInEditMode =
          rowModesModel[params.id]?.mode === GridRowModes.Edit;

        if (isInEditMode) {
          return [
            <BootstrapTooltip title="ذخیره">
              <GridActionsCellItem
                icon={<SaveIcon color="success" />}
                label="Save"
                sx={{
                  color: "primary.main",
                }}
                onClick={handleSaveClick(params.id)}
              />
            </BootstrapTooltip>,
            <BootstrapTooltip title="انصراف">
              <GridActionsCellItem
                icon={<CancelIcon color="error" />}
                label="Cancel"
                className="textPrimary"
                onClick={handleCancelClick(params.id)}
                color="inherit"
              />
            </BootstrapTooltip>,
          ];
        }

        const actions = [
          <BootstrapTooltip title="نمایش لیست">
            <GridActionsCellItem
              icon={<ChecklistRtlIcon color="info" />}
              label="Save"
              sx={{
                color: "primary.main",
              }}
              onClick={() => {
                handleShowSaleFunnel(params.row);
              }}
            />
          </BootstrapTooltip>,
        ];

        // اضافه کردن دکمه ویرایش اگر دسترسی داشته باشد
        if (canEdit("sales-funnel")) {
          actions.push(
            <BootstrapTooltip title="ویرایش">
              <GridActionsCellItem
                icon={<EditIcon color="primary" />}
                label="ویرایش"
                className="textPrimary"
                onClick={handleEditClick(params.id)}
                color="inherit"
              />
            </BootstrapTooltip>
          );
        }

        // اضافه کردن دکمه حذف اگر دسترسی داشته باشد
        if (canDelete("sales-funnel")) {
          actions.push(
            <BootstrapTooltip title="حذف">
              <GridActionsCellItem
                icon={<DeleteIcon color="error" />}
                label="حذف"
                onClick={(event) =>
                  handleDeleteClick(event, params.id.toString())
                }
                color="inherit"
              />
            </BootstrapTooltip>
          );
        }

        return actions;
      },
    },
  ];
  const [openSaleFunnelItemInfo, setOpenSaleFunnelItemInfo] =
    useState<boolean>(false);
  const [getSaleFunnel, setSaleFunnel] = useState<ISaleFunnel>(
    {} as ISaleFunnel
  );

  const handleShowSaleFunnel = (saleFunnelItem: ISaleFunnel) => {
    setOpenSaleFunnelItemInfo(true);
    setSaleFunnel(saleFunnelItem);
  };

  const { mutateAsync: updateAsync, isPending: isEditLoading } = useMutation({
    mutationFn: async (body: any) => {
      const response = await fetch(API_URL + "sale-funnel/" + body.id, {
        method: "PUT",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json-patch+json",
          Authorization: `Bearer ${user?.token}`,
        },
        body: JSON.stringify(body),
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      notifications.show("خطا در دریافت اطلاعات", {
        severity: "error",
        autoHideDuration: 3000,
      });
      console.log("eee", error);
    },
  });

  const { mutateAsync: deleteAsync, isPending: isDeleteLoading } = useMutation({
    mutationFn: async () => {
      const response = await fetch(API_URL + "sale-funnel/" + bankId, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${user?.token}`,
          Aceept: "application/json",
        },
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      notifications.show("خطا در دریافت اطلاعات", {
        severity: "error",
        autoHideDuration: 3000,
      });
      console.log(error);
    },
  });

  const [bankId, setBankId] = useState("");

  const [anchorDeleteEl, setAnchorDeleteEl] =
    useState<HTMLButtonElement | null>(null);
  const openDeletePopover = Boolean(anchorDeleteEl);
  const idDeletePopover = openDeletePopover ? "simple-popover" : undefined;
  const handleDeleteClick = (
    event: MouseEvent<HTMLButtonElement>,
    id: string
  ) => {
    setAnchorDeleteEl(event.currentTarget);
    setBankId(id);
  };
  const handleDeletePopoverClose = () => {
    setAnchorDeleteEl(null);
  };
  const handleDelete = async () => {
    try {
      const res = await deleteAsync();
      if (res.status) {
        notifications.show("حذف با موفقیت انجام شد!", {
          severity: "success",
          autoHideDuration: 5000,
        });
      } else {
        notifications.show("خطا در حذف!", {
          severity: "error",
          autoHideDuration: 5000,
        });
      }
    } catch (error) {
      console.log("🚀 ~ handleDelete ~ error:", error);
      notifications.show("خطا در حذف!", {
        severity: "error",
        autoHideDuration: 5000,
      });
    } finally {
      refetch();
      handleDeletePopoverClose();
    }
  };

  function EditToolbar() {
    return (
      <GridToolbarContainer>
        <ActionPermissionGuard menuId="sales-funnel" permission="create">
          <Button
            color="primary"
            startIcon={<AddIcon />}
            onClick={() => setOpenTask(true)}
          >
            قیف فروش جدید
          </Button>
        </ActionPermissionGuard>
      </GridToolbarContainer>
    );
  }
  const handleEditClick = (id: GridRowId) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };

  const handleSaveClick = (id: GridRowId) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };

  const processRowUpdate = async (newRow: GridRowModel) => {
    const updatedRow = { ...newRow, isNew: false };
    const res = await updateAsync(updatedRow);
    if (res.status) {
      refetch();
      setRows(
        rows.map((row: any) => (row.id === newRow.id ? updatedRow : row))
      );
      notifications.show("تغییرات اعمال شد!", {
        severity: "success",
        autoHideDuration: 5000,
      });
    } else {
      notifications.show("مشکل در ذخیره ساز!", {
        severity: "error",
        autoHideDuration: 5000,
      });
    }
    return updatedRow;
  };

  const handleCancelClick = (id: GridRowId) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = rows.find((row: any) => row.id === id);
    if (editedRow!.isNew) {
      setRows(rows.filter((row: any) => row.id !== id));
    }
  };
  const handleClose = () => {
    setOpenTask(false);
  };
  const handleCloseSaleFunnel = () => {
    setOpenSaleFunnelItemInfo(false);
  };
  return (
    <PermissionGuard menuId="sales-funnel" permission="view">
      <>
        <PageTitle title="قیف فروش" />
        <PopoverComponent
          caption=" حذف انجام شود؟"
          anchorEl={anchorDeleteEl}
          handlePopoverClose={handleDeletePopoverClose}
          handler={handleDelete}
          id={idDeletePopover}
          isLoading={isDeleteLoading}
          open={openDeletePopover}
          key={"delete"}
        />

        <NewSaleFunnel
          open={openTask}
          handleClose={handleClose}
          refetch={refetch}
          // data={rowInfo}
        />
        <ShowSalesFunnelInfo
          saleFunnel={getSaleFunnel}
          handleClose={handleCloseSaleFunnel}
          open={openSaleFunnelItemInfo}
        />

        <Box>
          {isLoading ? (
            <SkeltonProgress />
          ) : (
            <GridViewMUIX
              gridUniqueName="SalesFunnelList"
              columns={columns}
              loading={isLoading || isEditLoading}
              EditToolbar={EditToolbar}
              rowModesModel={rowModesModel}
              processRowUpdate={processRowUpdate}
              sortFields={{ field: "modifiedOn", sort: "desc" }}
              rows={rows}
              setRowModesModel={setRowModesModel}
            />
          )}
        </Box>
      </>
    </PermissionGuard>
  );
};

export default SalesFunnelList;
